module.exports = __webpack_public_path__ + "static/media/pyDataGlobalLogo.d2e542b0.png";